import { CustomTextField } from '../../../common/components';
import { drawerFieldSpan as span } from '../../../common/styles';

/**
 * Campo de texto del drawer de proveedor con su error y su ancho en la grilla de 12 columnas.
 * @param {Object} props
 * @param {string} props.name Campo del formulario.
 * @param {string} props.label Etiqueta.
 * @param {number} props.size Columnas que ocupa en `md`.
 * @param {Object|null} props.form Estado del formulario.
 * @param {Object} props.errors Errores por campo.
 * @param {Function} props.onChange Cambia un campo.
 * @returns {JSX.Element}
 */
const ProviderTextField = ({ name, label, size, form, errors, onChange, ...extra }) => (
  <CustomTextField
    label={label}
    name={name}
    value={form?.[name] || ''}
    onChange={onChange}
    error={Boolean(errors[name])}
    helperText={errors[name]}
    sx={span(size)}
    {...extra}
  />
);

export default ProviderTextField;
